module.exports = __webpack_public_path__ + "img/success-modal.0ec604c3.svg";